<template>
  <div>
    <!-- <div class="bg-white-wrapper">
      <div class="container location">
        <Breadcrumb class="breadcrumb" separator="»">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>学习中心</BreadcrumbItem>
          <BreadcrumbItem>我的直播</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </div> -->
    <div class="container live-tab">
      <ul>
        <li :class="tabIndex == 0 ? 'active' : ''" @click="changeTab(0)">
          <a href="javascript:;">全部直播</a>
        </li>
        <li :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">
          <a href="javascript:;">我的直播</a>
        </li>
      </ul>
      <div class="live-search">
        <input
          v-model="keywords"
          type="text"
          placeholder="请输入直播主题名称"
          class="live-search-input"
        />
        <Button
          type="primary"
          shape="circle"
          style="width: 80px"
          @click="searchData()"
          >搜索</Button
        >
      </div>
    </div>
    <div class="container live-wrapper">
      <div class="live-nodata" v-show="!liveList || liveList.length <= 0">
        <img src="../../assets/images/nodata-02.png" alt="no-data" />
        <p v-if="!isLogin || loginUser.ugid === 6">
          当前账号为试用账号或未登录状态<br />请登录后查看我的直播
        </p>
        <p v-else-if="keywords">～找不到相关直播～</p>
        <p v-else>～暂无最新直播～</p>
      </div>
      <Timeline v-show="liveList && liveList.length > 0">
        <TimelineItem v-for="(item, index) in liveList" :key="index">
          <Icon
            type="ios-radio-button-on"
            size="22"
            color="#0092e6"
            slot="dot"
            v-if="item.liveStatus === 1"
          />
          <Icon
            type="ios-radio-button-on"
            size="20"
            color="#ccc"
            slot="dot"
            v-else
          />
          <div class="live-item">
            <div class="live-item-date">
              <template v-if="item.liveStatus === 1">
                <div class="live-item-day">直播中</div>
                <div class="live-item-time">
                  <live-playing></live-playing>
                </div>
              </template>
              <template v-else>
                <div class="live-item-day">
                  <!-- <span>{{ item.dateTime }}</span> <span>{{ item.week }}</span> -->
                  <span>{{ dateFormat(item.startDate, "yyyy年MM月dd") }}</span>
                </div>
                <div class="live-item-time">{{ item.timeHF }}</div>
              </template>
            </div>
            <div class="live-item-avatar">
              <Avatar
                shape="square"
                icon="ios-person"
                :src="concatImageUrl(item.roomId, 70, 70)"
                size="70"
                v-if="item.roomId"
              />
              <Avatar
                shape="square"
                icon="ios-person"
                :src="require('../../assets/images/live-default.png')"
                size="70"
                v-else
              />
            </div>
            <div class="live-item-info">
              <h3>{{ item.title }}</h3>
              <p>
                <span>讲师：{{ item.teacherName }}</span
                ><span>{{ item.introduce }}</span>
              </p>
            </div>
            <div class="live-item-btn">
              <Badge :text="item.tag">
                <Button
                  v-if="item.liveStatus === 0"
                  type="primary"
                  shape="circle"
                  disabled
                  long
                  >还未开始</Button
                >
                <Button
                  v-else-if="item.liveStatus === 1"
                  type="primary"
                  shape="circle"
                  long
                  @click="handlePlay(item)"
                  >正在直播</Button
                >
                <Button
                  v-else-if="item.liveStatus === 2 && item.playbackStatus === 4"
                  type="primary"
                  shape="circle"
                  long
                  @click="handlePlay(item)"
                  >观看回放</Button
                >
                <Button v-else type="primary" shape="circle" long disabled
                  >生成中</Button
                >
              </Badge>
            </div>
          </div>
        </TimelineItem>
      </Timeline>
      <div class="page" v-show="liveList && liveList.length > 0">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
          show-elevator
          show-total
        />
      </div>
    </div>

    <Modal
      v-model="errorModalVisible"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span style="margin-left: 0.5rem">友情提示</span>
      </p>
      <p>&nbsp;</p>
      <div v-html="errorMessage"></div>
      <div slot="footer" style="text-align: center">
        <Button type="error" @click="errorModalVisible = false">知道了</Button>
        <template v-if="sidebarQQList.length > 0">
          <a :href="sidebarQQList[0].url" :target="sidebarQQList[0].type"
            ><Button type="success" style="margin-left: 30px"
              >联系老师</Button
            ></a
          >
        </template>
        <!-- <template
          v-else-if="siteConfig.sidebarQQ && siteConfig.sidebarQQType == 3"
        >
          <a :href="{}" :target="{}"
            ><Button type="success" style="margin-left: 30px">联系老师</Button></a
          >
        </template>
        <template
          v-else-if="siteConfig.sidebarQQ && siteConfig.sidebarQQType == 4"
        >
          <a :href="{}" :target="{}"
            ><Button type="success" style="margin-left: 30px">联系老师</Button></a
          >
        </template> -->
      </div>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
import { addJs, dateFormat } from "../../utils/utils";
import LivePlaying from "../../components/common/LivePlaying";
export default {
  mixins: [siteMixin],
  data() {
    return {
      tabIndex: 0,
      keywords: "",
      liveList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      errorMessage: "",
      errorModalVisible: false,
      dateFormat,
    };
  },
  computed: {
    sidebarQQList() {
      if (
        this.siteConfig.sidebarQQType != 1 &&
        this.siteConfig.sidebarQQType != 2
      ) {
        return [];
      }
      if (!this.siteConfig.sidebarQQ) return [];
      let list = [];
      const personQQ = process.env.VUE_APP_PERSON_QQ;
      const companyQQ = process.env.VUE_APP_COMPANY_QQ;
      this.siteConfig.sidebarQQ.split(",").forEach((item, index) => {
        let url = personQQ.replace("{0}", item);
        let type = "_blank";
        if (this.siteConfig.sidebarQQType === 2) {
          url = companyQQ.replace("{0}", item);
          type = "qiyeqq";
        }
        list.push({
          type,
          qq: item,
          url,
        });
      });
      return list;
    },
  },
  mounted() {
    this.getDataList();
    //this.setFooterJs();
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index;
      this.getDataList();
    },
    getDataList() {
      const isAllLive = this.tabIndex === 0 ? "1" : "";
      const isTryUser = this.loginUser.ugid === 6 ? "1" : "";
      study
        .getLiveList(
          this.loginUser.userId,
          this.keywords,
          this.pageIndex,
          isAllLive,
          isTryUser
        )
        .then((res) => {
          //console.log("liveList", res);
          if (res.status === 1) {
            const result = res.data.pageInfo;
            this.totalCount = result.total;
            this.liveList = result.list;
          }
        });
    },
    searchData() {
      this.scrollTop();
      this.pageIndex = 1;
      this.getDataList();
    },
    changePage(page) {
      this.scrollTop();
      this.pageIndex = page;
      this.getDataList();
    },
    livePlay(item) {
      study
        .saveLiveTime(this.loginUser.userId, item.channelId, item.id)
        .then((res) => {
          // window.location.href=item.playUrl;
        });
    },
    handlePlay(item) {
      if (item.isLook === 1) {
        study
          .saveLiveTime(this.loginUser.userId, item.channelId, item.id)
          .then((res) => {});
        //  this.$router.push({ name: "LiveIndex", params: { id: item.id } });
        const url = this.$router.resolve({
          name: "LiveIndex",
          params: { id: item.id },
        });
        window.open(url.href, "_blank"); //打开新窗口
      } else {
        this.errorMessage =
          "抱歉，此直播只针对开通该课程的学员开放，请联系教务老师了解更多";
        this.errorModalVisible = true;
      }
    },
    // handleReplay(item) {
    //   if (item.isLook === 1) {
    //     study
    //       .saveLiveTime(this.loginUser.userId, item.channelId, item.id)
    //       .then((res) => {});
    //     this.$router.push({ name: 'LiveReplay', params: { id: item.id } });
    //   } else {
    //     this.errorMessage =
    //       '抱歉，此直播只针对开通该课程的学员开放，请联系教务老师了解更多';
    //     this.errorModalVisible = true;
    //   }
    // },
    setFooterJs() {
      //初始化底部脚本信息
      const lead = "http://lead.soperson.com/{0}.js";
      const baidu = "https://hm.baidu.com/hm.js?{0}";
      if (this.siteConfig.sidebarQQ) {
        if (this.siteConfig.sidebarQQType == 3) {
          addJs(lead.replace("{0}", this.siteConfig.sidebarQQ));
        }
        if (this.siteConfig.sidebarQQType == 4) {
          addJs(baidu.replace("{0}", this.siteConfig.sidebarQQ));
        }
      }
      const cnzz = "https://s11.cnzz.com/z_stat.php?id={0}&web_id={0}";
      if (this.siteConfig.agencyId == 0) {
        addJs(
          "https://s11.cnzz.com/z_stat.php?id=1261806431&web_id=1261806431"
        );
      } else if (this.siteConfig.cnzzStatisKey) {
        const url = cnzz.replace(/\{0\}/g, this.siteConfig.cnzzStatisKey);
        addJs(url);
      }
    },
  },
  components: {
    LivePlaying,
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
.sultan-a {
  background: linear-gradient(to right, #27a3ff, #2380fb);
  border: none;
  border-radius: 32px;
  color: #fff;
  width: 100%;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  line-height: 32px;
  user-select: none;
  height: 32px;
  padding: 0 15px;
  font-size: 14px;
  transition: color 0.2s linear, background-color 0.2s linear,
    border 0.2s linear, box-shadow 0.2s linear;
}
.location {
  padding: 10px 0;
}
.live-tab {
  padding: 10px 0 0 0;
  background: #fff;
  margin: 20px auto;
  border-radius: 10px;
  ul {
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
    font-size: 0;
    padding-left: 20px;
    li {
      margin-right: 25px;
      display: inline-block;
      vertical-align: top;
      a {
        display: inline-block;
        padding: 10px 6px;
        font-size: 1.6rem;
        font-weight: bold;
        min-width: 80px;
        text-align: center;
      }
    }
    .active {
      a {
        border-bottom: 6px solid #0e90d2;
        color: #0e90d2;
      }
    }
  }
  .live-search {
    float: right;
    margin: 5px 20px 0 0;
    &-input {
      height: 32px;
      line-height: 30px;
      font-size: 14px;
      margin: 0 20px;
      outline: none;
      border: 1px solid #eee;
      width: 260px;
      background-color: #f5f5f5;
      padding: 0 16px;
      border-radius: 30px;
      .inline-block();
    }
  }
}
.live-wrapper {
  border-radius: 10px;
  min-height: 300px;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  padding-top: 80px;
  .live-nodata {
    text-align: center;
    img {
      display: inline-block;
    }
  }
  .live-item {
    display: flex;
    border: 2px solid #eee;
    padding: 20px;
    align-items: center;
    margin-top: -50px;
    margin-bottom: 50px;
    background-color: #fff;
    border-radius: 6px;
    .live-item-date {
      width: 120px;
      padding: 0 10px;
      margin-right: 20px;
      line-height: 2;
      text-align: center;
    }
    .live-item-avatar {
      width: 90px;
    }
    .live-item-info {
      flex: 1;
      line-height: 2;
      p {
        span {
          margin-right: 20px;
          .inline-block();
          .ellipsis();
          &:first-child {
            width: 100px;
          }
          &:last-child {
            color: #666;
            width: 630px;
          }
        }
      }
    }
    .live-item-btn {
      width: 90px;
      text-align: center;
      margin-right: 20px;
    }
  }
  .page {
    position: relative;
    text-align: center;
    margin-top: -25px;
    padding-bottom: 20px;
  }
}
</style>
